import { Fragment } from 'react';
import { Desktop } from './Desktop';
import { Mobile } from './Mobile';
export function Sidebar() {
    return (<Fragment>
      <Mobile />
      <Desktop />
    </Fragment>);
}
